<div
	[class]="cn(!isOpen() && 'hidden', isOpen() && 'block')"
	class="w-full overflow-hidden rounded-t-md bg-white shadow-[rgba(0,0,0,0.1)_0px_0px_12px]"
>
	<div class="flex border-b border-b-ui-75">
		<span class="p-4 text-xl font-semibold">
			{{ sheetTitle() }}
		</span>
		<button
			(click)="toggleEvent()"
			class="ml-auto p-4"
			data-test-id="close"
		>
			<svg-icon
				class="block size-6 text-dark-primary"
				src="assets/icons/icon-cross.svg"
			/>
		</button>
	</div>
	@let items = sheetItems();
	@if (items.length > 0) {
		<vp-link-list
			[linkListItems]="items"
			[preventNavigation]="preventNavigation()"
			(linkClicked)="onItemClicked($event)"
		/>
	}
</div>
